import createContext from '@ant-design/create-react-context';
var RowContext = createContext({});
export default RowContext;
//# sourceMappingURL=RowContext.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/grid/RowContext.js
// module id = 325
// module chunks = 0